import React from 'react'

const CookieContext = React.createContext({
  cookieValue: null,
  setCookieValue: () => {},
  setShowCookiesConsent: () => {}
});

export default CookieContext
